import "./index.less";
import "reflect-metadata";
import {di} from "@dp-instant/core";
import {GameModuleBase, startGame} from "@dp-instant/game-template";
import {GameModuleYandex} from "@dp-instant/social-ya";
import {TypesSocial} from "@dp-instant/interfaces";
import {PauseActionHomoEvolution} from "./actions/PauseActionHomoEvolution";
import {AdsProviderCommon} from "./ported/AdsProviderCommon";
import {GameModule} from "./module/GameModule";

di.load(GameModuleBase);
di.load(GameModuleYandex);
di.load(GameModule);

di.isBound(TypesSocial.pauseAction)
    ? di.rebind(TypesSocial.pauseAction).to(PauseActionHomoEvolution)
    : di.bind(TypesSocial.pauseAction).to(PauseActionHomoEvolution);

di.bind("AdsProviderCommon").toConstantValue(AdsProviderCommon);

startGame();
